import HeaderComponent from "src/Components/Header";
import FooterComponent from "src/Components/Footer";
import AboutUsLayout from "src/Layouts/AboutUs";

const FAQsPage = () => {
  return (
    <>
      <div className="min-h-full">
        <HeaderComponent />
        <main>
          <div className="mx-auto max-w-7xl py-6 sm:px-6 lg:px-8">
            <AboutUsLayout />
          </div>
        </main>
        <FooterComponent />
      </div>
    </>
  );
};

export default FAQsPage;
